import './helpers.js';
import './config.js';
import { b as registerComponent, u as use } from './plugins-f72cbfce.js';
import './Icon-311893d1.js';
import './FormElementMixin-97156cdb.js';
import './Input-3186e79f.js';
import { _ as __vue_component__ } from './Autocomplete-dfc4a7e5.js';
export { _ as OAutocomplete } from './Autocomplete-dfc4a7e5.js';

const Plugin = {
  install(Vue) {
    registerComponent(Vue, __vue_component__);
  }

};
use(Plugin);

export default Plugin;
